import { FunctionComponent } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import Module, {
  AllowedThemes,
  ModuleContainer,
  themesMap,
} from '@components/undock/modules'
import { RichTextI } from '@lib/contentful/entries/pages/legal'
import {
  DocumentWrapper,
  LastUpdated,
  Title,
} from '@components/undock/modules/richText/style'
import { DateTime } from 'luxon'

interface RichTextModulePropsI extends RichTextI {
  themeName?: AllowedThemes
}
const RichTextModule: FunctionComponent<RichTextModulePropsI> = ({
  document = null,
  lastUpdated = null,
  themeName = 'light',
  title = 'NO_TITLE_PROVIDED',
}) => {
  return (
    <Module theme={themesMap[themeName]}>
      <ModuleContainer>
        <Title>{title}</Title>
        {lastUpdated && (
          <LastUpdated>
            Last updated:&nbsp;
            {DateTime.fromFormat(lastUpdated, 'yyyy-MM-dd').toLocaleString(
              DateTime.DATE_FULL
            )}
          </LastUpdated>
        )}
        <DocumentWrapper>
          {document && documentToReactComponents(document)}
        </DocumentWrapper>
      </ModuleContainer>
    </Module>
  )
}

export default RichTextModule
